import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { isContrySupportedZipCode } from '../../../address/utils';
import MobileDropdownDrawer from '@app/components/common/MobileDropdownDrawer';
import { PCC_CHECKOUT_PAGES_DRAWERS_MOBILE } from '@app/constants/featureFlags';

const CountryField = ({ countries, setIsZipCodeSupported }) => {
  const [t] = useTranslation();
  const { setValue } = useFormContext();

  const countriesHaveNoZipOrState = useSelector(
    state => state?.dealer?.countriesHaveNoZipOrState
  );

  const isPCCCheckoutPagesDrawersMobile = useSelector(
    s => s.featureFlag[PCC_CHECKOUT_PAGES_DRAWERS_MOBILE]
  );

  const countriesList = countries.map(({ displayName }) => displayName);

  const additionalBehaviour = value => {
    setValue('state', '');
    setIsZipCodeSupported(
      isContrySupportedZipCode(value, countries, countriesHaveNoZipOrState)
    );
  };

  return (
    <MobileDropdownDrawer
      label={t('COUNTRY_REGION')}
      fieldId="country"
      dataTestId="country"
      items={countriesList}
      required
      requiredValidationMessage={t('1626_FIELD_REQUIRED_ERROR')}
      additional={additionalBehaviour}
      withSearch={isPCCCheckoutPagesDrawersMobile}
      searchPlaceHolder={t('SEARCH_COUNTRY_REGION')}
    />
  );
};

CountryField.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      states: PropTypes.arrayOf(
        PropTypes.shape({
          code: PropTypes.string,
          displayName: PropTypes.string
        })
      )
    })
  ),
  setIsZipCodeSupported: PropTypes.func
};

export default CountryField;
